import { useMemo } from "react";
import { useRelay } from "./relayContext.tsx";
import type { GitSetupApi } from "./gitSetup.ts";

/** Binds the shared Git Setup requests to one Machine + Project. All Git work happens on the Machine Agent. */
export function useGitSetupApi(machineId: string | undefined, projectId: string | undefined): GitSetupApi | null {
  const relay = useRelay();
  return useMemo(() => {
    if (!machineId || !projectId) return null;
    return {
      check: () => relay.machine(machineId, "system/git.readiness", { projectId }),
      status: () => relay.machine(machineId, "system/git.status", { projectId }),
      diff: () => relay.machine(machineId, "system/git.diff", { projectId }),
      installPlan: () => relay.machine(machineId, "system/git.installPlan", {}),
      install: () => relay.machine(machineId, "system/git.install", {}),
      prepare: ({ identity }) =>
        relay.machine(machineId, "system/git.prepare", {
          projectId,
          confirmed: true,
          ...(identity ? { identity } : {}),
        }),
      commit: ({ message, identity }) =>
        relay.machine(machineId, "system/git.commit", {
          projectId,
          message,
          ...(identity ? { identity } : {}),
        }),
      discard: () => relay.machine(machineId, "system/git.discard", { projectId }),
    };
  }, [relay, machineId, projectId]);
}
